import { formatMoneyWhole } from '@app/shared'
import { Meter } from '../ui'
import './giving-cards.css'

export type GivingCard = {
  key: string
  name: string
  line: string | null
  appeal: string | null
  goalCents: number | null
  pledgedCents: number | null
  act: string
  href: string
}

/**
 * The funds an org is collecting for, as cards: each its name, its one line,
 * the opening of its story and, where the office publishes it, how far along
 * it is. The whole card is the link to the fund's page, where the story is
 * read whole.
 *
 * The grid answers its own measure: as many cards as fit at a readable width,
 * one where one fits.
 */
export function GivingCards({ cards }: { cards: GivingCard[] }) {
  return (
    <ul className="gcards">
      {cards.map((c) => (
        <li key={c.key} className="gcards__item">
          <a className="gcard" href={c.href}>
            <span className="gcard__name">{c.name}</span>
            {c.line ? <span className="gcard__line">{c.line}</span> : null}
            {c.appeal ? (
              <span className="gcard__story">{opening(c.appeal)}</span>
            ) : null}
            <span className="gcard__foot">
              {c.goalCents && c.pledgedCents !== null ? (
                <span className="gcard__progress">
                  <Meter
                    share={c.pledgedCents / c.goalCents}
                    label={`${formatMoneyWhole(c.pledgedCents)} of ${formatMoneyWhole(c.goalCents, 'up')}`}
                  />
                  <span className="gcard__figures">
                    {formatMoneyWhole(c.pledgedCents)} of{' '}
                    {formatMoneyWhole(c.goalCents, 'up')}
                  </span>
                </span>
              ) : null}
              <span className="gcard__act" aria-hidden>
                {c.act}
              </span>
            </span>
          </a>
        </li>
      ))}
    </ul>
  )
}

/** A story's first paragraph: the card shows how it opens, and the fund's
 *  page reads it whole. */
function opening(appeal: string): string {
  return appeal.split(/\n\s*\n/)[0]?.trim() ?? ''
}
